/**
 * Alphabet excludes visually ambiguous glyphs (I l O 0 1) so the manager can
 * dictate the password over the phone without mistakes.
 */
const SAFE_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789';

export function generatePassword(length = 16): string {
  const bytes = crypto.getRandomValues(new Uint32Array(length));
  return Array.from(bytes, (b) => SAFE_ALPHABET[b % SAFE_ALPHABET.length]).join('');
}
